import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

export const DisplayHideContentAnimation = (hideSeconds: number = 0.25): AnimationTriggerMetadata => {
  return trigger('displayHideContent', [
    state('display', style({
      // empty to get it's proper display from css, where it's based on media queries
    })),
    state('hide', style({
      display: 'none'
    })),
    transition('display => hide', [
      animate(`${hideSeconds}s`)
    ]),
    transition('hide => display', [
      animate('0s')
    ]),
  ]);
};
